<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="ct1" id="toc_marker-5"><a href="#/OEBPS/The_Hanging_Wood2#Contents-A"><span>Map</span></a><span></span></p>
<p class="fp"><span class="calibre1"><img alt="MartinFinal2map.jpg" class="frame2" src="OEBPS/image/MartinFinal2map_fmt.png"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// The_Hanging_Wood-4.vue?2b64ad89